(function () {
  if (!customElements.get("custom-recharge")) {
    function updatePrice(currentVariant, form, plan, salePrice, planSelector) {
      let cartPrice = currentVariant.dataset.price;
      if (plan) {
        cartPrice = plan.cartPrice;
        form
          .querySelectorAll(".js-sale-plan-price")
          ?.forEach((salePriceEl, i) => {
            salePriceEl.innerHTML = plan.price;
            salePriceEl
              .closest(".subscr-box__prices-container")
              ?.classList.add("is-on-sale");
          });
      }
      if (salePrice) {
        form.querySelectorAll(".js-sale-price")?.forEach((salePriceEl, i) => {
          salePriceEl.innerHTML = salePrice;
          salePriceEl
            .closest(".subscr-box__prices-container")
            ?.classList.add("is-on-sale");
        });
      }

      form
        .querySelectorAll(".subscr-box__prices-container")
        ?.forEach((salePriceEl, i) => {
          salePriceEl
            .closest(".subscr-box__prices-container")
            ?.classList.add("loaded");
        });

      form.querySelectorAll(".js-product-price")?.forEach((productPrice, i) => {
        productPrice.innerHTML = currentVariant.dataset.price;
      });

      form.querySelectorAll(".js-cart-price")?.forEach((priceEl, i) => {
        priceEl.innerHTML = cartPrice;
      });
    }

    function checkOptionsMatch(currentOptions, variantDataset) {
      for (const key in currentOptions) {
        if (
          variantDataset.hasOwnProperty(key) &&
          currentOptions[key] !== variantDataset[key]
        ) {
          return false;
        }
      }
      return true;
    }

    function changeVariant(currentVariant, form) {
      if (currentVariant) {
        var variantSelector = form.querySelector(".js-all-variants");
        variantSelector.value = currentVariant.value;
        const planSelector = form.querySelector(".js-plan-selector:checked");
        const planId = planSelector?.value;

        let plans = [];
        try {
          plans = JSON.parse(currentVariant.dataset.recharge);
        } catch (error) {}

        const plan =
          form.querySelector(".js-subscr-box.active")?.dataset.subscr === "true"
            ? plans.find((plan) => plan.id === planId)
            : false;

        const salePrice =
          currentVariant.dataset.salePrice !== currentVariant.dataset.price
            ? currentVariant.dataset.salePrice
            : 0;

        let qty = 1;
        let planFormInput = form.querySelector(".js-selling-plan-input");
        let planPropId = form.querySelector(".js-plan-prop-id");
        let hiddenQtyInput = form.querySelector(".js-hidden-qty");
        let hiddenNameInput = form.querySelector(".js-hidden-name");
        let hiddenBillingFrequencyInput = form.querySelector(
          ".js-hidden-billing-frequency"
        );

        // plan id update
        if (plan && plan.id && planFormInput) {
          qty = plan.qty;
          planFormInput.value = plan.id;
          planPropId ? (planPropId.value = plan.id) : "";
          hiddenNameInput.value = plan.planName;
        } else if (planFormInput) {
          planFormInput.value = "";
          planPropId ? (planPropId.value = planPropId.dataset.default) : "";
        }

        if (plan) {
          if (hiddenNameInput) {
            hiddenNameInput.disabled = false;
          }
          if (hiddenBillingFrequencyInput) {
            hiddenBillingFrequencyInput.value = plan.billing_frequency;
            hiddenBillingFrequencyInput.disabled = false;
          }
        } else {
          if (hiddenNameInput) {
            hiddenNameInput.disabled = true;
          }
          if (hiddenBillingFrequencyInput) {
            hiddenBillingFrequencyInput.disabled = true;
          }
        }

        // qty update:
        let qtyInput = form.querySelector(".js-qty-input");
        if (qtyInput) {
          qtyInput.value = qty;
          hiddenQtyInput.value = qty;
        }

        // price update:
        updatePrice(currentVariant, form, plan, salePrice);
      }
    }

    function getCurrentVariant(form) {
      var variantSelector = form.querySelector(".js-all-variants");
      var currentVariant =
        variantSelector.options[variantSelector.selectedIndex];
      return currentVariant;
    }

    class customRecharge extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.form = this.closest(".js-product-form");
        
        // Set active pill to first visible if no active pill exists
        // Ensure active pill exists but DO NOT click it
const activePill = this.form.querySelector('.product__subs__group-subscription.active-pill');

if (!activePill) {
  const firstVisiblePill = this.form.querySelector('.product__subs__group-subscription:not([style*="display: none"])');
  if (firstVisiblePill) {
    firstVisiblePill.classList.add('active-pill');
  }
}

// Sync variant + plan silently (no click)
changeVariant(getCurrentVariant(this.form), this.form);

        this.form
          .querySelectorAll(".js-product-option")
          ?.forEach(function (btn, i) {
            var form = btn.closest(".js-product-form");
            btn.addEventListener("click", function (e) {
              btn
                .closest(".js-options-group")
                .querySelectorAll(".js-product-option")
                .forEach(function (btn) {
                  btn.classList.remove("active");
                });
              btn.classList.add("active");

              var currentVariant;
              var currentOptions = {};
              form
                .querySelectorAll(".js-product-option.active")
                .forEach(function (option) {
                  const key = `option-${option.dataset.index}`;
                  currentOptions[key] = option.dataset.value;
                });
              form
                .querySelectorAll(".js-all-variants option")
                .forEach(function (variant) {
                  if (checkOptionsMatch(currentOptions, variant.dataset)) {
                    currentVariant = variant;
                  }
                });

              if (currentVariant) {
                changeVariant(currentVariant, form);
              }
            });
          });

        this.form
          .querySelectorAll(".js-plan-selector")
          .forEach((planSelector) => {
            planSelector.addEventListener("change", function (e) {
              const form = this.closest(".js-product-form");
              form
                .querySelectorAll(".js-plan-pill")
                .forEach(function (planPill) {
                  planPill.classList.remove("active-pill");
                });

              this.closest(".js-plan-pill").classList.add("active-pill");
              changeVariant(getCurrentVariant(form), form);
            });
          });

        this.form.querySelectorAll(".js-subscr-box")?.forEach(function (box) {
          box.addEventListener("click", function () {
            const form = this.closest(".js-product-form");
            form.querySelectorAll(".js-subscr-box").forEach(function (box) {
              box.classList.remove("active");
              box.querySelectorAll(".subs-inner").forEach(function (inner) {
                inner.style.maxHeight = "0px";
              });
            });
            box.classList.add("active");
            box.querySelectorAll(".subs-inner").forEach(function (inner) {
              inner.style.maxHeight = inner.scrollHeight + "px";
            });
            changeVariant(getCurrentVariant(form), form);
          });
        });
      }
    }

    customElements.define("custom-recharge", customRecharge);
  }
})();

